<template>
  <div class="chat-container">
    <button v-if="!isOpen" id="chat-button" @click="toggleChat" aria-label="Abrir chat">
      <i class="fas fa-headset"></i>
    </button>

    <transition name="fade">
      <div v-if="isOpen" id="chat-window">
        <div class="chat-header">
          <div>
            <strong>Suporte Técnico</strong>
          </div>
          <button class="close text-white" @click="toggleChat">&times;</button>
        </div>

        <div class="chat-body" ref="chatContent">
          <div v-for="(msg, index) in mensagens" :key="index" @click="handleClick"
            :class="['msg', msg.type === 'bot' ? 'msg-in' : 'msg-out']">
            <div v-if="msg.text" v-html="msg.text"></div>
          </div>
        </div>
        <span class="ml-3 text-secondary" v-if="typing">Digitando...</span>
        <div class="chat-footer">
          <form @submit.prevent="sendMessage">
            <div class="input-group">
              <input v-model="newText" type="text" class="form-control border-0 bg-light"
                placeholder="Escreva aqui..." :disabled="input_text"
                v-if="!search_client_document && !validate_code">
              <input type="text" class="form-control border-0 bg-light" id="document" aria-describedby="documentHelp"
                placeholder="xx.xxx.xxx/xxxx-xx" v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="newText"
                :disabled="input_text" v-if="search_client_document && !validate_code">
              <input type="text" class="form-control border-0 bg-light" id="document" aria-describedby="documentHelp"
                placeholder="Informe o código..." v-mask="['####']" v-model="newText" :disabled="input_text"
                v-if="!search_client_document && validate_code">

              <div class="input-group-append">
                <button class="btn btn-primary" type="submit">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import axios from 'axios';
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  name: 'ChatSuporte',
  data() {
    return {
      isOpen: false,
      newText: '',
      mensagens: [],
      start_support: false,
      end_support: false,
      search_client_document: false,
      matters: false,
      validate_code: false,
      status_protocol: false,
      generate_protocol: false,
      search_protocol: false,
      register_new_message: false,
      input_text: true,
      subject: 'Diversos',
      polling: null,
      searchForNewMessages: false,
      clientId: '',
      email: '',
      url_api: '',
      typing: false
    };
  },
  beforeUnmount() {
    clearInterval(this.polling);
  },
  mounted() {
    this.url_api = process.env.VUE_APP_URL_API;
  },
  methods: {
    injectMessage(type, text) {
      this.mensagens.push({ type: type, text: text });
    },
    messageWellcome() {
      if (this.start_support) {
        this.start_support = true;
        this.injectMessage('bot', '<p class="text-justify">Olá! Seja bem-vindo(a) ao nosso suporte.');
        this.injectMessage('bot', '<p class="text-justify">Para iniciarmos, preciso que me informe o documento CNPJ (<strong>se possui empresa</strong>) ou seu CPF, caso não possua, para que possamos identificá-lo.</p>');
        this.input_text = false;
        this.search_client_document = true;
        this.start_support = false;
      }
    },
    messageMatters() {
      setTimeout(() => {
        this.injectMessage('bot', '<button class="btn btn-default btn-sm duplicate_payment">Segunda via boleto</button>');
      }, 2100);

    },
    messageclientLogged() {
      const name = localStorage.getItem('name');
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Olá ' + name + ', tudo bem? Como podemos te ajudar hoje?</p>');
        this.scrollToBottom();
      }, 1000);
      this.loading = false;

    },
    messageSearchDocument() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Por gentileza, informe seu <strong>CNPJ</strong>, caso seja Pessa Júrica, ou seu <strong>CPF</strong>, se Pessoa Física.</p>');
        this.scrollToBottom();
      }, 2000);
      this.loading = false;

    },
    messageHelpToday() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Entendi. Como podemos ajudá-lo(a) hoje?</p>');
        this.scrollToBottom();
      }, 2000);
    },
    messageValidateCodeEmail() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Entendi. Para sua segurança, enviamos um código de identificação para o e-mail: <strong>' + this.email + '</strong>. Por favor, informe o código abaixo: </p>');
        this.scrollToBottom();
      }, 2000);


    },
    messageStatusProtocol() {

      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Por gentileza, informe o número do protocolo. Ele segue o seguinte padrão: <strong>xxxx-xxxxxx</strong></p>');
        this.scrollToBottom();
      }, 2000);

    },
    messageProtocolGegenerate(protocol, date, hour) {

      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Sua mensagem já está conosco e em breve alguém do nosso time irá respondê-lo(a), tudo bem? Seu nº de protocolo é: <strong>' + protocol + '</strong> aberto em ' + date + ' às ' + hour + '</p>');
        this.scrollToBottom();
      }, 2000);

    },

    loadNewMessages() {
      const protocol = localStorage.getItem('protocol_help_desk');
      this.polling = setInterval(() => {
        if (this.searchForNewMessages) {
          this.searchProtocol(protocol);
        }

      }, 100000);
    },
    handleClick(e) {
      const duplicate_payment = e.target.closest(".duplicate_payment");
      const status_protocol = e.target.closest(".status_protocol");
      const general_questions = e.target.closest(".general_questions");
      const stop_chat = e.target.closest(".stop_chat");

      if (duplicate_payment) {
        this.typing = true;
        this.injectMessage('client', '<p>Segunda via boleto</p>');
        this.input_text = false;
        this.validateCodeEmail();
        this.search_client_document = false;
        this.generate_protocol = false;
        this.search_protocol = false;
        this.matters = false;
        this.validate_code = true;
        this.subject = 'Segunda via boleto';
        setInterval(() => { this.typing = false }, 1500);
      } else if (status_protocol) {
        this.injectMessage('client', '<p>Status protocolo</p>');
        this.input_text = false;
        this.messageStatusProtocol();
        this.generate_protocol = false;
        this.search_protocol = true;
        this.matters = false;
        this.subject = 'Consultar protocolo';
      } else if (general_questions) {
        this.injectMessage('client', '<p>Dúvidas Gerais</p>');
        this.input_text = false;
        this.messageHelpToday();
        this.generate_protocol = true;
        this.search_protocol = false;
        this.matters = false;
        this.subject = 'Dúvidas gerais';
      } else if (stop_chat) {
        this.injectMessage('client', '<p>Encerrar chamada</p>');
        this.injectMessage('bot', '<p class="text-justify">Seu atendimento foi encerrado. Agradecemos pelo contato.</p>');
        this.input_text = false;
        this.false = true;
        this.generate_protocol = false;
        this.search_protocol = false;
        this.register_new_message = false;
        this.matters = false;
      }

      this.scrollToBottom();

    },
    converterLinks(text) {
      const regexUrl = /((https?:\/\/)|(www\.))[^\s]+/g;

      return text.replace(regexUrl, (url) => {
        let href = url;
        if (url.toLowerCase().startsWith('www.')) {
          href = 'http://' + url;
        }

        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    },
    toggleChat() {
      this.isOpen = !this.isOpen;
      this.searchForNewMessages = !this.searchForNewMessages;
      //Verifica se existe algum protocolo em aberto
      const protocol = localStorage.getItem('protocol_help_desk');
      if (protocol != null) {
        this.searchProtocol(protocol);
        this.loadNewMessages();
        this.register_new_message = true;
        this.input_text = false;
      } else {
        //Verifica se existe um client_id já setado. Se sim, prosseguir para perguntas do que deseja. Do contrário, dar boas-vindas
        const client_id = localStorage.getItem('client_id');
        if (client_id != null) {
          this.clientId = client_id;
          if (this.mensagens.length <= 0) {
            this.typing = true;
            this.start_support = false;
            this.matters = true;
            this.email = localStorage.getItem('email');
            this.messageclientLogged();
            this.messageMatters();
            setInterval(() => { this.typing = false; }, 3000);
          }

        } else {
          if (this.mensagens.length <= 0) {
            this.start_support = true;
            this.messageWellcome();
          }
        }

      }
      if (this.isOpen) {
        this.scrollToBottom();
      }
    },

    stopHelpDesk() {
      this.stopTicket();

    },

    searchDocumentClient(document) {
      //Busca informação banco de dados
      axios.get(this.url_api + '/search-client/' + document, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          this.loading = false;
          if (response.data.email != '') {
            this.search_client_document = false;
            this.matters = true;
            this.clientId = response.data.client;
            this.email = response.data.email;
            localStorage.setItem('client_id', response.data.client);
            localStorage.setItem('name', response.data.name);
            localStorage.setItem('email', response.data.email);
            this.mensagens = [];
            this.injectMessage('bot', '<p class="text-justify">Encontramos o seu cadastro. Agora, por gentileza, poderia escolher qual assunto deseja tratar?</p>');
            this.messageMatters();
            this.input_text = true;
            this.scrollToBottom();
          } else {
            this.injectMessage('bot', '<p class="text-justify">Encontramos o seu cadastro, porém, não há um e-mail vinculado para validarmos. Por gentileza, entre em contato com o suporte para atualizar o seu cadastroo.</p>');
          }

        }).catch(error => {
          console.log(error);
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    validateCodeEmail() {
      axios.post(this.url_api + '/generate-code-validation/' + this.clientId, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      })
        .then(() => {
          this.isLoading = false;
          this.typing = true;
          this.messageValidateCodeEmail();
          setTimeout(() => {
            this.typing = true;
          }, 2000);
        }).catch(error => {
          this.isLoading = false;
          handleRequestErrors(error.status);
        })
    },

    searchProtocol(protocol) {
      //Busca informação banco de dados
      api.get('/search-protocol/' + protocol)
        .then((response) => {
          this.loading = false;
          if (response.data.data.status == 'Finalizado') {
            this.mensagens = [];
            this.injectMessage('bot', '<p class="text-justify">Olá! O protocolo de nº <strong>' + protocol + '</strong> foi encerrado. Caso precise, pode abrir um novo chamado.</p>');
            localStorage.removeItem('protocol_help_desk');
            this.start_support = false;
            this.this.search_client_document = true;
            this.messageSearchDocument();
            this.input_text = false;
            return;
          }
          if (response.data.data.messages.length <= 1 && this.mensagens.length == 0) {
            this.injectMessage('bot', '<p class="text-justify">Olá! Nosso time ainda está analisando sua mensagem e responderá o protocolo de nº <strong>' + protocol + '</strong> o mais breve possível.</p>');
          } else {
            this.mensagens = [];
            let messages = response.data.data.messages;
            messages.forEach(message => {
              this.injectMessage(message.agent, '<p class="text-justify">' + this.converterLinks(message.message) + '</p>');
            });
            this.register_new_message = true;
            this.search_client_document = false;
            this.matters = false;
            this.status_protocol = false;
            this.generate_protocol = false;
            this.search_protocol = false;
          }
          localStorage.setItem('protocol_help_desk', protocol);
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar  o protocolo. Por gentileza, poderia verificar se informou corretamente os números, no padrão <strong>xxxx-xxxxxx</strong>');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    createNumberProtocol(message) {
      api.get('/create-number-protocol', {
        params: {
          'subject': this.subject,
          'type': 'text',
          'client_id': localStorage.getItem('client_id'),
          'message': message
        }
      })
        .then((response) => {
          this.loading = false;
          localStorage.setItem('protocol_help_desk', response.data.data.protocol);
          const number_protocol = response.data.data.protocol;
          const date_start_protocol = response.data.data.created_at_date;
          const hour_start_protocol = response.data.data.created_at_hour;
          this.mensagens = [];
          this.injectMessage('client', message);
          this.messageProtocolGegenerate(number_protocol, date_start_protocol, hour_start_protocol);
          this.loadNewMessages();
          this.generate_protocol = false;
          this.matters = true;
          this.register_new_message = true;
          this.input_text = false;
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },
    stopTicket() {
      const protocol = localStorage.getItem('protocol_help_desk');
      this.$confirm(
        {
          message: 'Deseja encerrar o suporte?',
          button: {
            no: 'Não',
            yes: 'Sim'
          },

          callback: confirm => {
            if (confirm) {
              api.post('/close-protocol/' + protocol)
                .then(() => {
                  this.isLoading = false;
                  this.$notify({
                    title: "Sucesso",
                    text: "Suporte encerrado com sucesso",
                    type: 'success'
                  });
                  this.loading = false;

                  this.novoText = '';
                  this.mensagens = [];
                  localStorage.removeItem('client_id');
                  localStorage.removeItem('name');
                  localStorage.removeItem('protocol_help_desk');
                  this.injectMessage('bot', '<p class="text-justify">Seu atendimento foi encerrado. Agradecemos pelo contato. E qualquer dúvida, estamos à disposição.</p>');
                  this.search_client_document = false;
                  this.end_support = false;
                  this.start_support = true;
                  setTimeout(() => {
                    this.isOpen = false;
                  }, 5000);
                }).catch(error => {
                  this.isLoading = false;
                  handleRequestErrors(error.status);
                })
            }
          }
        }
      )
    },

    verifyCode(code) {
      this.typing = true;
      axios.post(this.url_api + '/validate-code-client/' + this.clientId+'/'+code, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          this.loading = false;
          this.typing = false;
          const links = response.data.data;
          if(links.length > 0){
            this.injectMessage('bot', '<p class="text-justify">Foram identificadas '+links.length+' cobrança(s) em aberto para o documento informado:</p>');
            links.forEach(link => {
              const link_open = link.link != ''?'<p><a href="'+link.link+'" target="_blank">Visualizar cobrança</p>':'';
              this.injectMessage('bot', '<span><p>Valor: '+link.amount+'</p><p>Vencimento:'+link.due_date+link_open+'</p></span>');
            });
          }else{
              this.injectMessage('bot', '<p class="text-justify">Não foram identificadas cobranças em aberto para o documento informado =).</p>');
          }
          
          this.search_client_document = false;
          this.validate_code = false;
          this.input_text = true;
           this.scrollToBottom();

        }).catch(error => {
          console.log(error);
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', '<p class="text-justify">Desculpe-nos, mas o <strong>código</strong> informado parece está <strong>incorreto</strong>. Poderia tentar novamente, por gentileza?</p>');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    registerMessage(message_send) {
      let message = message_send.trim();
      api.post('/register-message/' + localStorage.getItem('protocol_help_desk'), {
        'type': 'text',
        'message': message,
        'agent': 'client'

      })
        .then(() => {
          this.newText = '';
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo enviar a mensagem no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    sendMessage() {
      if (this.newText.trim() === '') return;

      this.injectMessage('client', this.newText);
      this.scrollToBottom();
      const message_send = this.newText.toLocaleLowerCase();
      this.newText = '';
      // Simulação de resposta
      setTimeout(() => {
        if (this.novoText != '') {
          if (this.end_support) {
            this.start_support = true;
            this.end_support = false;
            this.loading = false;
            this.novoText = '';
            return;
          }

          if (this.start_support) {
            this.messageSearchDocument();
            this.start_support = false;
            this.search_client_document = true;
          } else if (this.search_client_document) {
            let message_sanatize = message_send.replace(/\D/g, '');
            this.searchDocumentClient(message_sanatize);
          } else if (this.matters && !this.generate_protocol) {
            this.loading = false;
            this.injectMessage('bot', '<p class="text-justify">Por gentileza, poderia escolher qual assunto deseja tratar?</p>');
            this.messageMatters();
          } else if (this.generate_protocol && !this.register_new_message) {
            this.createNumberProtocol(message_send);
          } else if (this.search_protocol) {
            this.searchProtocol(message_send);
          } else if (this.register_new_message) {
            this.registerMessage(message_send);
          } else if (this.validate_code) {
            this.verifyCode(message_send);
          }

        }
        this.scrollToBottom();
      }, 2000);

    },
    triggerFile() {
      this.$refs.fileInput.click();
    },
    anexarArquivo(event) {
      const file = event.target.files[0];
      if (file) {
        this.mensagens.push({
          type: 'client',
          file: file.name
        });
        this.scrollToBottom();
      }
    },
    scrollToBottom() {
      // O nextTick garante que o DOM foi atualizado antes de rolar
      this.$nextTick(() => {
        const container = this.$refs.chatContent;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  }
};
</script>

<style scoped>
/* Copie o CSS anterior aqui e adicione a animação de transição do Vue */
#chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #042F5F;
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

#chat-window {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 380px;
  height: 700px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 1050;
  overflow: hidden;
}

.chat-header {
  background: #042F5F;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-body {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
}

.msg {
  margin-bottom: 12px;
  padding: 10px 15px;
  border-radius: 18px;
  font-size: 14px;
  max-width: 85%;
}

.msg-in {
  background-color: #fff;
  align-self: flex-start;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.msg-out {
  background-color: #042F5F;
  color: white;
  align-self: flex-end;
}

.attachment-msg {
  font-size: 12px;
  font-style: italic;
  border: 1px dashed #ccc;
  padding: 5px;
  margin-top: 5px;
  border-radius: 5px;
}

.chat-footer {
  padding: 10px;
  border-top: 1px solid #eee;
  background: white;
}

/* Transição do Vue */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.list-none{
  list-style-type:none;
}

@media (max-width: 576px) {
  #chat-window {
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .chat-footer {
    padding-bottom: 10px;
  }
}
</style>